module.exports = __webpack_public_path__ + "./static/img/icon-2.e5663055c59fbcb2be01506a685301be.png";


//////////////////
// WEBPACK FOOTER
// ./client/src/assets/img/company/icon-2.png
// module id = ./client/src/assets/img/company/icon-2.png
// module chunks = 0